import {axios as http} from "@/plugins/http"

export default class Api {
    static categories(startId) {
        let config = {
            params: {
                start_id: startId,
            },
        }

        return http.get("/api/v1/wishlist/category", config).then((resp) => {
            return resp.data["items"]
        })
    }
}
